export default __webpack_public_path__ + "static/media/Honored Jerkin of the Tribes.18a96ebd.jpg";